import CommonItemFlag from 'components/common-item/CommonItemFlag';
import CommonItemInfo from 'components/common-item/CommonItemInfo';
import CommonItemTag from 'components/common-item/CommonItemTag';
import useActiveItem from 'hooks/useActiveItem';
import { useSoundPath } from 'hooks/useSoundPath';
import { CardPacksContext } from 'pages/CardPacks';
import { PrizesContext } from 'pages/Prizes';
import React, { useContext } from 'react'
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setactiveItem } from 'store/cards';

const CombineList = ({items}) => {

  const {pathname} = useLocation();
  const navigate = useNavigate();
  const {activeItem} = useActiveItem();
  const playSound = useSoundPath();
  const dispatch = useDispatch();
  const getContext = () => {
    if (pathname.includes('/prizes')) {
      return PrizesContext;
    } else if (pathname.includes('/inventory/card-packs')) {
      return CardPacksContext;
    }
  }
  const {selectMode, selectedItems, setSelectedItems} = useContext(getContext());

  const getIsChecked = (id) => selectedItems.find((item) => item.id === id ? true : false)

  const addselectedItems = (e, value, id, tag) => {
    if (tag !== 'Redeemable') {
      const matches = selectedItems.find((prize) => prize.id === id);

      if (!matches) {
        setSelectedItems((prevState) => [
          ...prevState,
          {
            id: id,
            cost: value
          }
        ]);
      } else if(matches) {
        setSelectedItems((prevState) =>
          prevState.filter((prize) => prize.id !== id)
        );
      }
    } else if(tag === 'Redeemable') {
      e.preventDefault();
    }
  };

  return (
    <ul
      className={`cards-list__block ${
        items.length | activeItem && "cards-list__block--min"
      }`}
    >
      {items.map((item) => (
        <li
          key={item.id}
          className={`cards-list__block-item ${
            activeItem === item ? "active" : ""
          } ${selectMode && item.tag === "Redeemable" ? "disabled" : ""}`}
          onClick={(e) => {
            if (!selectMode) {
              dispatch(setactiveItem(item));
              playSound('main');
            } else {
              addselectedItems(e, Number(item.name), item.id, item.tag);
            }
          }}
          onDoubleClick={() => {
            if (pathname.includes('inventory/card-packs')) {
              navigate(`/inventory/card-pack-open/${item.id}`);
              console.log('onDoubleClick');

            }
          }}
        >
          <CommonItemInfo
            name={item.name}
            type={item.type}
            image={item.image}
            props={item.properties}
          />
          <p
            className={`cards-list__block-item-text ${
              selectMode && item.tag !== "Redeemable"
                ? "cards-list__block-item-text--select-mode"
                : ""
            }`}
          >
            <span>
              {item.type.toLowerCase() === 'prize' && '$'}
              {item.name}
            </span>
            {selectMode && item.tag !== "Redeemable" && (
              <>
                <input
                  type="checkbox"
                  value={item.name}
                  checked={getIsChecked(item.id)}
                  id={item.id}
                />
                <label
                  htmlFor={item.id}
                  onClick={(e) => e.stopPropagation()}
                  className="cards-list__block-item-text-select"
                ></label>
              </>
            )}
          </p>
          <CommonItemTag tag={item.tag} />
          <CommonItemFlag isListed={item.is_listed} isMine={item.owned_by_self} />
        </li>
      ))}
    </ul>
  );
}

export default CombineList
